/**
 * AvatarStack primitive (Plan 01-16, Task 3).
 *
 * Renders N PixelAvatars overlapping with `-ml-2` between them. UI-SPEC
 * §Component Inventory uses this for: (a) the dashboard chores tile
 * weekly leader avatar cluster, (b) phone event rows showing who is
 * involved in an event.
 *
 * Each wrapper carries `data-avatar-index={i}` so visual-regression
 * tests can target individual portraits without DOM-traversal
 * gymnastics.
 */
import { PixelAvatar } from './PixelAvatar';
import type { ColorSlot } from './PixelAvatar';

interface AvatarStackProps {
  colorSlots: ReadonlyArray<ColorSlot>;
  size?: number;
  className?: string;
}

export function AvatarStack({
  colorSlots,
  size = 32,
  className,
}: AvatarStackProps) {
  return (
    <div
      className={['flex items-center', className].filter(Boolean).join(' ')}
    >
      {colorSlots.map((slot, i) => (
        <div
          key={`${slot}-${i}`}
          data-avatar-index={i}
          className={i === 0 ? '' : '-ml-2'}
        >
          <PixelAvatar colorSlot={slot} size={size} />
        </div>
      ))}
    </div>
  );
}
